export const CONTENT_TYPE = 'Content-Type';
export const CONTENT_DISPOSITION = 'Content-Disposition';
